(function () {
  'use strict';

  var SHOP_NAME = window.SHOP_NAME || 'HAAM Styles';

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  function initHeroSlider(slider) {
    if (!slider || slider.dataset.heroReady === 'true') return;

    var backgrounds = slider.querySelectorAll('[data-hero-bg]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var current = 0;
    var total = backgrounds.length;
    var autoplay = slider.dataset.autoplay !== 'false';
    var intervalMs = parseInt(slider.dataset.interval, 10) || 1000;
    var timer = null;

    function goTo(index) {
      if (total <= 1) return;
      current = (index + total) % total;
      backgrounds.forEach(function (bg, i) {
        bg.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      clearInterval(timer);
      timer = setInterval(next, intervalMs);
    }

    function stopAutoplay() {
      clearInterval(timer);
      timer = null;
    }

    slider._heroStartAutoplay = startAutoplay;
    slider._heroStopAutoplay = stopAutoplay;

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    slider.dataset.heroReady = 'true';
    startAutoplay();
  }

  function initAllHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }

  function restartHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      if (slider._heroStartAutoplay) slider._heroStartAutoplay();
    });
  }

  initAllHeroSliders();

  window.addEventListener('pageshow', restartHeroSliders);

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      if (document.visibilityState === 'hidden') {
        if (slider._heroStopAutoplay) slider._heroStopAutoplay();
      } else if (slider._heroStartAutoplay) {
        slider._heroStartAutoplay();
      }
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('[data-hero-slider]');
    if (slider) {
      slider.dataset.heroReady = '';
      initHeroSlider(slider);
    }
  });

  document.querySelectorAll('[data-marquee]').forEach(function (bar) {
    var track = bar.querySelector('[data-marquee-track]');
    var group = track && track.querySelector('.marquee-bar__group');
    if (!track || !group) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      bar.classList.add('marquee-bar--static');
      return;
    }

    var offset = 0;
    var speed = 0;
    var targetSpeed = 0;
    var groupWidth = 0;
    var lastTime = 0;
    var hovering = false;
    var fastDuration = 11;
    var slowDuration = 42;

    function measure() {
      groupWidth = group.offsetWidth;
      var nextTarget = groupWidth / (hovering ? slowDuration : fastDuration);
      if (!lastTime) {
        speed = nextTarget;
        targetSpeed = nextTarget;
      } else {
        targetSpeed = nextTarget;
      }
    }

    function setHoverState(isHovering) {
      hovering = isHovering;
      measure();
    }

    function tick(timestamp) {
      if (!lastTime) lastTime = timestamp;
      var delta = Math.min((timestamp - lastTime) / 1000, 0.05);
      lastTime = timestamp;

      speed += (targetSpeed - speed) * (1 - Math.exp(-delta * 2.2));

      if (groupWidth > 0) {
        offset += speed * delta;
        if (offset >= groupWidth) offset -= groupWidth;
        track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }

      requestAnimationFrame(tick);
    }

    measure();
    window.addEventListener('resize', measure);
    bar.addEventListener('mouseenter', function () { setHoverState(true); });
    bar.addEventListener('mouseleave', function () { setHoverState(false); });
    bar.addEventListener('focusin', function () { setHoverState(true); });
    bar.addEventListener('focusout', function () { setHoverState(false); });

    requestAnimationFrame(tick);
  });

  var reviewRowControllers = [];
  var REVIEW_STORAGE_KEY = 'royalJewellsUserReviews';
  var REVIEW_MIN_PUBLISH = 3.5;

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildStarsHtml(rating) {
    var full = Math.floor(rating);
    var fraction = rating - full;
    var showHalf = fraction >= 0.25 && fraction < 0.75;
    if (fraction >= 0.75) full += 1;
    var halfIndex = full + 1;
    var starPath = 'M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z';
    var html = '<div class="review-card__stars" aria-label="' + rating + ' out of 5 stars">';

    for (var i = 1; i <= 5; i += 1) {
      if (i <= full) {
        html += '<svg class="review-card__star" viewBox="0 0 24 24" aria-hidden="true"><path d="' + starPath + '" fill="currentColor"/></svg>';
      } else if (showHalf && i === halfIndex) {
        html += '<span class="review-card__star-half" aria-hidden="true">' +
          '<svg class="review-card__star review-card__star--empty" viewBox="0 0 24 24"><path d="' + starPath + '" fill="currentColor"/></svg>' +
          '<svg class="review-card__star review-card__star--half-fill" viewBox="0 0 24 24"><path d="' + starPath + '" fill="currentColor"/></svg>' +
          '</span>';
      } else {
        html += '<svg class="review-card__star review-card__star--empty" viewBox="0 0 24 24" aria-hidden="true"><path d="' + starPath + '" fill="currentColor"/></svg>';
      }
    }

    html += '</div>';
    return html;
  }

  function buildReviewCardHtml(review, isNew) {
    var classes = 'review-card is-user-review' + (isNew ? ' is-new-review' : '');
    return (
      '<article class="' + classes + '" data-user-review-id="' + review.id + '">' +
        buildStarsHtml(review.rating) +
        '<blockquote class="review-card__comment">' + escapeHtml(review.comment) + '</blockquote>' +
        '<footer class="review-card__meta">' +
          '<cite class="review-card__name">' + escapeHtml(review.name) + '</cite>' +
          '<time class="review-card__date">' + escapeHtml(review.date) + '</time>' +
        '</footer>' +
      '</article>'
    );
  }

  function getStoredReviews() {
    try {
      return JSON.parse(window.localStorage.getItem(REVIEW_STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveStoredReviews(reviews) {
    window.localStorage.setItem(REVIEW_STORAGE_KEY, JSON.stringify(reviews));
  }

  function formatReviewDate(date) {
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }

  function injectReviewCard(review, isNew) {
    if (review.rating < REVIEW_MIN_PUBLISH) return false;
    if (!reviewRowControllers.length) return false;
    if (document.querySelector('[data-user-review-id="' + review.id + '"]')) return false;

    var controller = reviewRowControllers[Math.floor(Math.random() * reviewRowControllers.length)];
    var html = buildReviewCardHtml(review, isNew);

    controller.groups.forEach(function (group) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var card = temp.firstElementChild;
      var cards = group.querySelectorAll('.review-card');
      var insertIndex = Math.floor(Math.random() * (cards.length + 1));
      if (!cards.length || insertIndex >= cards.length) {
        group.appendChild(card);
      } else {
        group.insertBefore(card, cards[insertIndex]);
      }
    });

    controller.measure();
    return true;
  }

  function loadStoredReviews() {
    getStoredReviews().forEach(function (review) {
      if (review.published) injectReviewCard(review, false);
    });
  }

  document.querySelectorAll('[data-reviews-rows]').forEach(function (section) {
    var rows = section.querySelectorAll('[data-reviews-row]');
    if (!rows.length) return;

    var autoplay = section.dataset.autoplay !== 'false';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shouldAnimate = autoplay && !reducedMotion;

    var hovering = false;
    var slowMultiplier = 3.2;

    section.addEventListener('mouseenter', function () { hovering = true; });
    section.addEventListener('mouseleave', function () { hovering = false; });
    section.addEventListener('focusin', function () { hovering = true; });
    section.addEventListener('focusout', function () { hovering = false; });

    rows.forEach(function (row) {
      var track = row.querySelector('[data-reviews-row-track]');
      var groups = track ? track.querySelectorAll('.reviews-row__group') : [];
      var group = groups[0];
      if (!track || !group || !groups.length) return;

      var direction = row.dataset.direction === 'ltr' ? 'ltr' : 'rtl';
      var duration = parseFloat(row.dataset.duration) || 14;
      var offset = 0;
      var speed = 0;
      var targetSpeed = 0;
      var groupWidth = 0;
      var lastTime = 0;

      function measure() {
        groupWidth = group.offsetWidth;
        var activeDuration = hovering ? duration * slowMultiplier : duration;
        var nextTarget = groupWidth / activeDuration;
        if (!lastTime) {
          speed = nextTarget;
          targetSpeed = nextTarget;
        } else {
          targetSpeed = nextTarget;
        }
      }

      reviewRowControllers.push({
        groups: Array.prototype.slice.call(groups),
        measure: measure
      });

      if (!shouldAnimate) return;

      function tick(timestamp) {
        if (!lastTime) lastTime = timestamp;
        var delta = Math.min((timestamp - lastTime) / 1000, 0.05);
        lastTime = timestamp;

        var activeDuration = hovering ? duration * slowMultiplier : duration;
        targetSpeed = groupWidth / activeDuration;
        speed += (targetSpeed - speed) * (1 - Math.exp(-delta * 2.2));

        if (groupWidth > 0) {
          offset += speed * delta;
          if (offset >= groupWidth) offset -= groupWidth;

          if (direction === 'ltr') {
            track.style.transform = 'translate3d(' + (offset - groupWidth) + 'px, 0, 0)';
          } else {
            track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
          }
        }

        requestAnimationFrame(tick);
      }

      measure();
      window.addEventListener('resize', measure);
      requestAnimationFrame(tick);
    });

    loadStoredReviews();
  });

  function initReviewModal() {
    var modal = document.querySelector('[data-review-modal]');
    if (!modal) return;

    var formWrap = modal.querySelector('[data-review-form-wrap]');
    var form = modal.querySelector('[data-review-form]');
    var successWrap = modal.querySelector('[data-review-success]');
    var successTitle = modal.querySelector('[data-review-success-title]');
    var successText = modal.querySelector('[data-review-success-text]');
    var errorEl = modal.querySelector('[data-review-error]');
    var starsWrap = modal.querySelector('[data-review-stars]');
    var ratingInput = modal.querySelector('[data-review-rating-input]');
    var ratingLabel = modal.querySelector('[data-review-rating-label]');
    var starBtns = starsWrap ? starsWrap.querySelectorAll('.review-stars__star') : [];
    var selectedRating = 0;

    function setRating(rating) {
      selectedRating = rating;
      if (ratingInput) ratingInput.value = String(rating);
      if (ratingLabel) {
        ratingLabel.textContent = rating ? rating + ' out of 5' : 'Select a rating';
      }

      starBtns.forEach(function (btn, index) {
        var starValue = index + 1;
        btn.classList.remove('is-active', 'is-filled', 'is-half');
        if (rating >= starValue) {
          btn.classList.add('is-active', 'is-filled');
        } else if (rating >= starValue - 0.5) {
          btn.classList.add('is-half');
        }
      });
    }

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockPageScroll();
      window.setTimeout(function () {
        var nameInput = form && form.querySelector('#ReviewName');
        if (nameInput) nameInput.focus();
      }, 280);
    }

    function resetModal() {
      if (form) form.reset();
      setRating(0);
      if (errorEl) errorEl.hidden = true;
      if (formWrap) formWrap.hidden = false;
      if (successWrap) successWrap.hidden = true;
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockPageScroll();
      window.setTimeout(resetModal, 320);
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-review-open]')) {
        event.preventDefault();
        openModal();
      }
      if (event.target.closest('[data-review-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (starsWrap) {
      starsWrap.addEventListener('mousemove', function (event) {
        var btn = event.target.closest('.review-stars__star');
        if (!btn) return;
        var index = parseInt(btn.getAttribute('data-star'), 10);
        var rect = btn.getBoundingClientRect();
        var half = event.clientX - rect.left < rect.width / 2;
        setRating(half ? index - 0.5 : index);
      });

      starsWrap.addEventListener('mouseleave', function () {
        setRating(selectedRating);
      });

      starsWrap.addEventListener('click', function (event) {
        var btn = event.target.closest('.review-stars__star');
        if (!btn) return;
        event.preventDefault();
        var index = parseInt(btn.getAttribute('data-star'), 10);
        var rect = btn.getBoundingClientRect();
        var half = event.clientX - rect.left < rect.width / 2;
        setRating(half ? index - 0.5 : index);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (errorEl) errorEl.hidden = true;

        var name = form.querySelector('#ReviewName').value.trim();
        var comment = form.querySelector('#ReviewComment').value.trim();
        var rating = parseFloat(ratingInput.value) || 0;

        if (!name || !comment || rating <= 0) {
          if (errorEl) {
            errorEl.textContent = 'Please add your name, rating, and review.';
            errorEl.hidden = false;
          }
          return;
        }

        var review = {
          id: 'user-' + Date.now(),
          name: name,
          comment: comment,
          rating: rating,
          date: formatReviewDate(new Date()),
          published: rating >= REVIEW_MIN_PUBLISH
        };

        var reviews = getStoredReviews();
        reviews.push(review);
        saveStoredReviews(reviews);

        if (review.published) {
          injectReviewCard(review, true);
          if (successTitle) successTitle.textContent = 'Review published!';
          if (successText) successText.textContent = 'Thank you — your review is now live in our customer gallery.';
        } else {
          if (successTitle) successTitle.textContent = 'Thank you!';
          if (successText) successText.textContent = 'We appreciate your honest feedback.';
        }

        if (formWrap) formWrap.hidden = true;
        if (successWrap) successWrap.hidden = false;
      });
    }
  }

  initReviewModal();

  document.querySelectorAll('[data-featured-carousel]').forEach(function (section) {
    var viewport = section.querySelector('.featured-section__viewport');
    var track = section.querySelector('[data-featured-track]');
    var prevBtn = section.querySelector('[data-featured-prev]');
    var nextBtn = section.querySelector('[data-featured-next]');
    if (!viewport || !track) return;

    function getScrollStep() {
      var card = track.querySelector('.featured-track__item');
      return card ? card.offsetWidth + 16 : 300;
    }

    function centerTrack() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (maxScroll > 0) {
        viewport.scrollLeft = maxScroll / 2;
      }
    }

    centerTrack();
    window.addEventListener('resize', centerTrack);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }
  });

  if (!document.querySelector('.hero-slider')) {
    var header = document.querySelector('.site-header');
    if (header) header.classList.add('site-header--solid');
  } else {
    var hdr = document.querySelector('.site-header');
    if (hdr) {
      hdr.classList.add('site-header--hero');
      var headerWasSolid = false;

      function updateHeaderOnScroll() {
        var shouldSolid = window.scrollY > 60;
        hdr.classList.toggle('site-header--solid', shouldSolid);
        hdr.classList.toggle('site-header--at-top', !shouldSolid);

        if (shouldSolid && !headerWasSolid) {
          hdr.classList.remove('is-header-animating');
          void hdr.offsetWidth;
          hdr.classList.add('is-header-animating');
          window.setTimeout(function () {
            hdr.classList.remove('is-header-animating');
          }, 500);
        }

        headerWasSolid = shouldSolid;
      }

      updateHeaderOnScroll();
      window.addEventListener('scroll', updateHeaderOnScroll, { passive: true });
    }
  }

  var scrollLockSelectors = '.site-header, .order-toast, .whatsapp-float';

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function lockPageScroll() {
    var scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
      document.querySelectorAll(scrollLockSelectors).forEach(function (el) {
        el.style.paddingRight = scrollbarWidth + 'px';
      });
    }
  }

  function unlockPageScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.querySelectorAll(scrollLockSelectors).forEach(function (el) {
      el.style.paddingRight = '';
    });
  }

  var toggle = document.querySelector('.site-header__toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      if (isOpen) {
        lockPageScroll();
      } else {
        unlockPageScroll();
      }
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        unlockPageScroll();
      });
    });
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerBody = document.querySelector('[data-cart-drawer-body]');
  var cartDrawerFoot = document.querySelector('[data-cart-drawer-foot]');
  var cartDrawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  var cartDrawerCheckout = document.querySelector('[data-cart-drawer-checkout]');
  var lastShopifyCart = { item_count: 0, total_price: 0, items: [] };
  var qtySyncTimers = {};

  function getDemoCart() {
    try {
      return JSON.parse(window.localStorage.getItem('royalJewellsDemoCart') || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveDemoCart(items) {
    window.localStorage.setItem('royalJewellsDemoCart', JSON.stringify(items));
  }

  function getDemoCartCount(items) {
    return items.reduce(function (sum, item) {
      return sum + (item.qty || 1);
    }, 0);
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return (cents / 100).toLocaleString('en-PK') + ' PKR';
  }

  function parsePkrPrice(str) {
    if (!str) return 0;
    return parseInt(String(str).replace(/[^\d]/g, ''), 10) || 0;
  }

  function formatPkrAmount(amount) {
    return amount.toLocaleString('en-PK') + ' PKR';
  }

  var GIFT_WRAP_PRICE = 100;

  function isGiftWrapFree(category) {
    return category === 'sets';
  }

  function getProductPageRoot(el) {
    return el.closest('.product-page__details, .product-page, #rj-product-view');
  }

  function getGiftWrapSelection(root) {
    if (!root) root = document;
    var checkbox = root.querySelector('[data-product-gift-wrap]');
    var category = root.getAttribute('data-product-category') || '';
    if (!checkbox) {
      return { selected: false, free: false, price: 0, category: category };
    }
    var selected = checkbox.checked;
    var free = selected && isGiftWrapFree(category);
    return {
      selected: selected,
      free: free,
      price: selected && !isGiftWrapFree(category) ? GIFT_WRAP_PRICE : 0,
      category: category
    };
  }

  function buildGiftWrapHtml(product) {
    var isSets = product.category === 'sets';
    var priceLabel = isSets ? 'Free for couple packs' : '+ Rs. 100';
    return (
      '<label class="product-page__gift-wrap">' +
        '<input type="checkbox" data-product-gift-wrap>' +
        '<span class="product-page__gift-wrap-box">' +
          '<span class="product-page__gift-wrap-icon" aria-hidden="true">🎁</span>' +
          '<span class="product-page__gift-wrap-text">' +
            '<strong>Gift wrapping</strong>' +
            '<small data-gift-wrap-label>' + priceLabel + '</small>' +
          '</span>' +
        '</span>' +
      '</label>'
    );
  }

  function getDemoSubtotal(items) {
    return items.reduce(function (sum, item) {
      var unit = item.priceValue || parsePkrPrice(item.price);
      var line = unit * (item.qty || 1);
      if (item.giftWrap && !isGiftWrapFree(item.category)) {
        line += GIFT_WRAP_PRICE;
      }
      return sum + line;
    }, 0);
  }

  function computeSubtotalText(shopifyCart, demoItems) {
    var shopifyCount = shopifyCart && shopifyCart.item_count ? shopifyCart.item_count : 0;
    var demoSum = getDemoSubtotal(demoItems || []);
    var shopifySum = shopifyCount ? shopifyCart.total_price / 100 : 0;
    var combined = shopifySum + demoSum;

    if (shopifyCount && demoSum) {
      return formatPkrAmount(combined);
    }
    if (shopifyCount) {
      return formatMoney(shopifyCart.total_price);
    }
    if (demoSum) {
      return formatPkrAmount(demoSum);
    }
    return '0 PKR';
  }

  function updateSubtotalDisplay() {
    var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
    var subtotalWrap = document.querySelector('[data-cart-drawer-subtotal-wrap]');
    if (!subtotalEl) return;

    subtotalEl.textContent = computeSubtotalText(lastShopifyCart, getDemoCart());

    if (subtotalWrap) {
      subtotalWrap.classList.remove('is-updated');
      void subtotalWrap.offsetWidth;
      subtotalWrap.classList.add('is-updated');
    }
  }

  function pulseCartIcon() {
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (icon) {
      icon.classList.remove('is-cart-pulse');
      void icon.offsetWidth;
      icon.classList.add('is-cart-pulse');
    });
  }

  function flyToCart(sourceBtn) {
    var card = sourceBtn.closest('.shop-card');
    var img = card && card.querySelector('.shop-card__img');
    var cartBtn = document.querySelector('[data-cart-drawer-open]');
    if (!img || !cartBtn) {
      pulseCartIcon();
      return;
    }

    var imgRect = img.getBoundingClientRect();
    var cartRect = cartBtn.getBoundingClientRect();
    var fly = img.cloneNode(true);
    fly.className = 'cart-fly-image';
    fly.style.left = imgRect.left + 'px';
    fly.style.top = imgRect.top + 'px';
    fly.style.width = imgRect.width + 'px';
    fly.style.height = imgRect.height + 'px';
    document.body.appendChild(fly);

    window.requestAnimationFrame(function () {
      fly.style.left = cartRect.left + cartRect.width / 2 - 14 + 'px';
      fly.style.top = cartRect.top + cartRect.height / 2 - 14 + 'px';
      fly.style.width = '28px';
      fly.style.height = '28px';
      fly.style.opacity = '0.15';
    });

    window.setTimeout(function () {
      fly.remove();
      pulseCartIcon();
    }, 620);
  }

  function showAddBurst(sourceBtn) {
    var inner = sourceBtn.closest('.shop-card') && sourceBtn.closest('.shop-card').querySelector('.shop-card__inner');
    if (!inner) return;

    var burst = document.createElement('div');
    burst.className = 'shop-add-burst';
    burst.innerHTML =
      '<span class="shop-add-burst__ring"></span>' +
      '<span class="shop-add-burst__check">' +
        '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">' +
          '<path fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>' +
        '</svg>' +
      '</span>';
    inner.appendChild(burst);
    window.setTimeout(function () { burst.remove(); }, 900);
  }

  function setQtyInDom(wrap, newQty) {
    wrap.setAttribute('data-current-qty', newQty);
    var val = wrap.querySelector('.cart-qty__value');
    if (!val) return;
    val.textContent = newQty;
    val.classList.remove('is-bump');
    void val.offsetWidth;
    val.classList.add('is-bump');
  }

  function setCartButtonLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
  }

  function playAddToCartFeedback(btn) {
    flyToCart(btn);
    showAddBurst(btn);
    btn.classList.remove('is-loading');
    btn.classList.add('is-success-flash');
    window.setTimeout(function () {
      btn.classList.remove('is-success-flash');
      btn.disabled = false;
    }, 650);
  }

  function buildQtyStepper(qty, shopifyKey, demoIndex) {
    var attrs = 'data-current-qty="' + qty + '"';
    if (shopifyKey) {
      attrs += ' data-shopify-key="' + shopifyKey + '"';
    } else {
      attrs += ' data-demo-index="' + demoIndex + '"';
    }
    return (
      '<div class="cart-qty" ' + attrs + '>' +
        '<button type="button" class="cart-qty__btn" data-qty-minus aria-label="Decrease quantity">−</button>' +
        '<span class="cart-qty__value">' + qty + '</span>' +
        '<button type="button" class="cart-qty__btn" data-qty-plus aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function getCartLineColor(item) {
    if (!item) return '';
    if (item.color) return item.color;
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }
    if (item.options_with_values && item.options_with_values.length) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        var opt = item.options_with_values[i];
        if (/colou?r/i.test(opt.name)) return opt.value;
      }
      return item.options_with_values[0].value;
    }
    if (item.variant_options && item.variant_options.length) {
      return item.variant_options[0];
    }
    var fullTitle = item.title || '';
    var productTitle = item.product_title || '';
    if (productTitle && fullTitle.length > productTitle.length) {
      var suffix = fullTitle.slice(productTitle.length).replace(/^[\s\-–—]+/, '').trim();
      if (suffix) return suffix;
    }
    return '';
  }

  function getColorSwatchId(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildCartColorSwatchHtml(variantTitle) {
    var title = String(variantTitle || '').trim();
    if (!title || title === 'Default Title') return '';
    var swatchId = getColorSwatchId(title);
    if (!swatchId) return '';
    return (
      '<span class="cart-drawer__item-color" aria-label="' + title.replace(/"/g, '&quot;') + '">' +
        '<span class="product-page__color-swatch product-page__color-swatch--' + swatchId + '" aria-hidden="true"></span>' +
      '</span>'
    );
  }

  function buildCartItemHtml(options) {
    var delay = options.delay || '0s';
    var colorSwatch = buildCartColorSwatchHtml(options.variantTitle);
    return (
      '<div class="cart-drawer__item' + (colorSwatch ? ' has-color' : '') + '" style="--item-delay:' + delay + '">' +
        (colorSwatch ? '<div class="cart-drawer__item-swatch">' + colorSwatch + '</div>' : '') +
        '<div class="cart-drawer__item-image">' +
          (options.image ? '<img src="' + options.image + '" alt="" width="72" height="72">' : '') +
        '</div>' +
        '<div class="cart-drawer__item-info">' +
          '<p class="cart-drawer__item-title"><span class="cart-drawer__item-name">' + options.title + '</span>' + (options.giftWrap ? ' <span class="cart-drawer__item-gift">🎁 Gift wrap</span>' : '') + '</p>' +
          '<p class="cart-drawer__item-price">' + options.price + (options.giftWrapFee ? ' <span class="cart-drawer__item-gift-fee">+ Rs. ' + options.giftWrapFee + '</span>' : '') + '</p>' +
          buildQtyStepper(options.qty, options.shopifyKey || null, options.demoIndex) +
        '</div>' +
      '</div>'
    );
  }

  function animateCartDrawerItems() {
    if (!cartDrawerBody) return;
    cartDrawerBody.querySelectorAll('.cart-drawer__item').forEach(function (item, index) {
      item.style.setProperty('--item-delay', (index * 0.05) + 's');
      item.classList.remove('is-animating');
      void item.offsetWidth;
      item.classList.add('is-animating');
    });
  }

  function updateDemoQty(index, newQty, options) {
    options = options || {};
    var cart = getDemoCart();
    if (index < 0 || index >= cart.length) return;

    if (newQty <= 0) {
      cart.splice(index, 1);
      saveDemoCart(cart);
      updateCartBadge();
      renderCartDrawer({ animate: false, skipFetch: true });
      renderDemoCartPage();
      return;
    }

    cart[index].qty = newQty;
    if (!cart[index].priceValue) {
      cart[index].priceValue = parsePkrPrice(cart[index].price);
    }
    saveDemoCart(cart);
    updateCartBadge();

    if (options.skipRender) {
      updateSubtotalDisplay();
      return;
    }

    renderCartDrawer({ animate: false });
    renderDemoCartPage();
  }

  function updateShopifyQty(lineKey, newQty, options) {
    options = options || {};
    if (newQty < 0) newQty = 0;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        lastShopifyCart = cart;
        updateCartBadge();
        if (options.skipFullRender) {
          updateSubtotalDisplay();
          return cart;
        }
        return renderCartDrawer({ animate: false });
      });
  }

  function handleQtyChange(wrap, newQty) {
    var shopifyKey = wrap.getAttribute('data-shopify-key');
    var demoIndex = wrap.getAttribute('data-demo-index');

    if (newQty <= 0) {
      var itemEl = wrap.closest('.cart-drawer__item');
      if (itemEl) itemEl.classList.add('is-removing');
      window.setTimeout(function () {
        if (shopifyKey) {
          updateShopifyQty(shopifyKey, 0);
        } else if (demoIndex !== null) {
          updateDemoQty(parseInt(demoIndex, 10), 0);
        }
      }, 220);
      return;
    }

    setQtyInDom(wrap, newQty);

    if (shopifyKey) {
      clearTimeout(qtySyncTimers[shopifyKey]);
      qtySyncTimers[shopifyKey] = window.setTimeout(function () {
        updateShopifyQty(shopifyKey, newQty, { skipFullRender: true });
      }, 280);
    } else if (demoIndex !== null) {
      updateDemoQty(parseInt(demoIndex, 10), newQty, { skipRender: true });
    }
  }

  function initCartDrawerEvents() {
    if (!cartDrawerBody || cartDrawerBody.dataset.qtyBound) return;
    cartDrawerBody.dataset.qtyBound = 'true';

    cartDrawerBody.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var wrap = event.target.closest('.cart-qty');
      if (!wrap) return;

      var qty = parseInt(wrap.getAttribute('data-current-qty'), 10) || 1;
      var shopifyKey = wrap.getAttribute('data-shopify-key');
      var demoIndex = wrap.getAttribute('data-demo-index');

      if (shopifyKey) {
        handleQtyChange(wrap, minus ? qty - 1 : qty + 1);
      } else if (demoIndex !== null) {
        handleQtyChange(wrap, minus ? qty - 1 : qty + 1);
      }
    });
  }

  initCartDrawerEvents();

  function openCartDrawer() {
    if (!cartDrawer) return;
    closeSearchModal();
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    lockPageScroll();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
  }

  function paintCartDrawer(shopifyCart, demoItems, shouldAnimate) {
    var html = '';
    var hasShopify = shopifyCart.item_count > 0;
    var hasDemo = demoItems.length > 0;

    if (!hasShopify && !hasDemo) {
      cartDrawerBody.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      if (cartDrawerFoot) cartDrawerFoot.hidden = true;
      updateSubtotalDisplay();
      return;
    }

    html += '<div class="cart-drawer__items">';

    shopifyCart.items.forEach(function (item, index) {
      html += buildCartItemHtml({
        title: item.product_title,
        variantTitle: getCartLineColor(item),
        price: formatMoney(item.final_price),
        qty: item.quantity,
        image: item.image,
        shopifyKey: item.key,
        delay: shouldAnimate ? (index * 0.05) + 's' : '0s'
      });
    });

    demoItems.forEach(function (item, index) {
      var giftFee = item.giftWrap && !isGiftWrapFree(item.category) ? GIFT_WRAP_PRICE : 0;
      html += buildCartItemHtml({
        title: item.title,
        variantTitle: item.color || '',
        price: item.price,
        qty: item.qty || 1,
        image: item.image,
        demoIndex: index,
        giftWrap: item.giftWrap,
        giftWrapFee: giftFee,
        delay: shouldAnimate ? ((shopifyCart.items.length + index) * 0.05) + 's' : '0s'
      });
    });

    html += '</div>';

    if (hasDemo && !hasShopify) {
      html = '<p class="cart-drawer__note">Demo items shown until real Shopify products are connected for checkout.</p>' + html;
    } else if (hasDemo && hasShopify) {
      html = '<p class="cart-drawer__note">Checkout uses your Shopify bag only. Clear old demo items if the list looks wrong.</p>' + html;
    }

    cartDrawerBody.innerHTML = html;
    if (shouldAnimate) animateCartDrawerItems();

    if (cartDrawerFoot) cartDrawerFoot.hidden = false;
    updateSubtotalDisplay();
    if (cartDrawerCheckout) {
      cartDrawerCheckout.textContent = 'Checkout';
      cartDrawerCheckout.href = hasShopify ? '/checkout' : '/pages/checkout';
    }
  }

  function renderCartDrawer(options) {
    options = options || {};
    var shouldAnimate = options.animate !== false;
    if (!cartDrawerBody) return Promise.resolve();

    var demoItems = getDemoCart();
    var demoOnly = !lastShopifyCart.item_count && demoItems.length;

    if (options.skipFetch && demoOnly) {
      paintCartDrawer(lastShopifyCart, demoItems, shouldAnimate);
      return Promise.resolve();
    }

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (shopifyCart) {
        lastShopifyCart = shopifyCart;
        paintCartDrawer(shopifyCart, getDemoCart(), shouldAnimate);
      })
      .catch(function () {
        lastShopifyCart = { item_count: 0, total_price: 0, items: [] };
        var items = getDemoCart();
        if (!items.length) {
          cartDrawerBody.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
          if (cartDrawerFoot) cartDrawerFoot.hidden = true;
          updateSubtotalDisplay();
          return;
        }

        var html = '<p class="cart-drawer__note">Demo cart — connect Shopify products for real checkout.</p><div class="cart-drawer__items">';
        items.forEach(function (item, index) {
          var giftFee = item.giftWrap && !isGiftWrapFree(item.category) ? GIFT_WRAP_PRICE : 0;
          html += buildCartItemHtml({
            title: item.title,
            variantTitle: item.color || '',
            price: item.price,
            qty: item.qty || 1,
            image: item.image,
            demoIndex: index,
            giftWrap: item.giftWrap,
            giftWrapFee: giftFee,
            delay: shouldAnimate ? (index * 0.05) + 's' : '0s'
          });
        });
        html += '</div>';
        cartDrawerBody.innerHTML = html;
        if (shouldAnimate) animateCartDrawerItems();
        if (cartDrawerFoot) cartDrawerFoot.hidden = false;
        updateSubtotalDisplay();
        if (cartDrawerCheckout) {
          cartDrawerCheckout.textContent = 'Complete Order';
          cartDrawerCheckout.href = '/pages/checkout';
        }
      });
  }

  function updateCartBadge() {
    var demoCount = getDemoCartCount(getDemoCart());
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        lastShopifyCart = cart;
        var total = cart.item_count + demoCount;
        document.querySelectorAll('.site-header__cart-badge').forEach(function (badge) {
          badge.textContent = total;
        });
      })
      .catch(function () {
        document.querySelectorAll('.site-header__cart-badge').forEach(function (badge) {
          badge.textContent = demoCount;
        });
      });
  }

  function renderDemoCartPage() {
    var mount = document.querySelector('[data-demo-cart-page]');
    if (!mount) return;

    var items = getDemoCart();
    if (!items.length) {
      mount.hidden = true;
      mount.innerHTML = '';
      document.querySelectorAll('[data-cart-empty]').forEach(function (el) {
        el.style.display = '';
      });
      return;
    }

    document.querySelectorAll('[data-cart-empty]').forEach(function (el) {
      el.style.display = 'none';
    });

    var rows = items.map(function (item, index) {
      return '<tr><td>' + item.title + '</td><td>' + item.price + '</td><td>' + (item.qty || 1) + '</td><td><button type="button" class="shop-demo-remove" data-demo-remove="' + index + '">Remove</button></td></tr>';
    }).join('');

    mount.hidden = false;
    mount.innerHTML =
      '<p style="color:var(--text-muted);font-size:0.85rem;margin:0 0 1rem;">Demo cart — add a real product in Shopify Admin for checkout.</p>' +
      '<table class="cart-table"><thead><tr><th>Item</th><th>Price</th><th>Qty</th><th></th></tr></thead><tbody>' +
      rows +
      '</tbody></table>' +
      '<div style="margin-top:2rem;display:flex;gap:1rem;flex-wrap:wrap;">' +
      '<a href="/collections/all" class="btn-shop" style="background:transparent;border:1px solid var(--border);color:var(--text);">Continue Shopping</a>' +
      '<a href="/pages/checkout" class="btn-shop">Checkout</a>' +
      '</div>';

    mount.querySelectorAll('[data-demo-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-demo-remove'), 10);
        var cart = getDemoCart();
        cart.splice(index, 1);
        saveDemoCart(cart);
        updateCartBadge();
        renderCartDrawer();
        renderDemoCartPage();
      });
    });
  }

  function getProductQtyFromBtn(btn) {
    var root = btn.closest('.product-page, #rj-product-view, .product-page__form');
    if (!root) root = document;
    var input = root.querySelector('[data-qty-input]');
    var qty = parseInt(input && input.value, 10);
    return Math.max(1, isNaN(qty) ? 1 : qty);
  }

  function getCartExtrasFromBtn(btn) {
    var root = getProductPageRoot(btn);
    var wrap = getGiftWrapSelection(root);
    var colorsRoot = root.querySelector('[data-product-colors]');
    var activeColor = colorsRoot ? colorsRoot.querySelector('[data-color].is-active') : null;
    var colorLabel = '';
    if (activeColor) {
      var nameEl = activeColor.querySelector('.product-page__color-name');
      colorLabel = nameEl ? nameEl.textContent.trim() : activeColor.getAttribute('data-color') || '';
    }
    var variantSelect = root.querySelector('[data-product-variant-select]');
    if (!colorLabel && variantSelect) {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt) colorLabel = opt.textContent.replace(/\s*—\s*Sold out$/i, '').trim();
    }
    return {
      giftWrap: wrap.selected,
      category: wrap.category || btn.getAttribute('data-product-category') || '',
      color: colorLabel
    };
  }

  function addDemoToCart(title, price, image, sourceBtn, quantity, extras) {
    extras = extras || {};
    var giftWrap = !!extras.giftWrap;
    var category = extras.category || '';
    var color = extras.color || '';
    var addQty = Math.max(1, parseInt(quantity, 10) || 1);
    var cart = getDemoCart();
    var found = false;
    cart.forEach(function (item) {
      if (item.title === title && !!item.giftWrap === giftWrap && (item.color || '') === color) {
        item.qty = (item.qty || 1) + addQty;
        found = true;
      }
    });
    if (!found) {
      cart.push({
        title: title,
        price: price,
        priceValue: parsePkrPrice(price),
        qty: addQty,
        image: image || '',
        giftWrap: giftWrap,
        category: category,
        color: color
      });
    }
    saveDemoCart(cart);
    updateCartBadge();
    if (sourceBtn) playAddToCartFeedback(sourceBtn);
    openCartDrawer();
    renderCartDrawer({ animate: !found, skipFetch: true });
    renderDemoCartPage();
  }

  function buyNowDemo(title, price, image, quantity, extras) {
    extras = extras || {};
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    saveDemoCart([{
      title: title,
      price: price,
      priceValue: parsePkrPrice(price),
      qty: qty,
      image: image || '',
      giftWrap: !!extras.giftWrap,
      category: extras.category || ''
    }]);
    updateCartBadge();
    window.location.href = (window.RJ_CONFIG && window.RJ_CONFIG.routes && window.RJ_CONFIG.routes.checkout) || '/pages/checkout';
  }

  function buyNowShopify(variantId, quantity) {
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' }
    }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      window.location.href = '/checkout';
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-open]')) {
      event.preventDefault();
      renderCartDrawer({ animate: false }).then(openCartDrawer);
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }

    if (event.target.closest('[data-search-open]')) {
      event.preventDefault();
      openSearchModal();
      return;
    }

    if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      closeSearchModal();
      return;
    }

    var buyNowBtn = event.target.closest('[data-buy-now]');
    if (buyNowBtn && !buyNowBtn.disabled) {
      event.preventDefault();
      event.stopPropagation();
      var buyVariantId = buyNowBtn.getAttribute('data-variant-id');
      var buyIsDemo = buyNowBtn.getAttribute('data-demo-cart') === 'true';
      var buyTitle = buyNowBtn.getAttribute('data-product-title') || 'Product';
      var buyPrice = buyNowBtn.getAttribute('data-product-price') || '';
      var buyImage = buyNowBtn.getAttribute('data-product-image') || '';
      var buyQty = getProductQtyFromBtn(buyNowBtn);

      if (buyIsDemo || !buyVariantId) {
        buyNowDemo(buyTitle, buyPrice, buyImage, buyQty, getCartExtrasFromBtn(buyNowBtn));
        return;
      }

      setCartButtonLoading(buyNowBtn, true);
      buyNowShopify(buyVariantId, buyQty).catch(function () {
        buyNowDemo(buyTitle, buyPrice, buyImage, buyQty, getCartExtrasFromBtn(buyNowBtn));
      });
      return;
    }

    var btn = event.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var isDemo = btn.getAttribute('data-demo-cart') === 'true';
    var productTitle = btn.getAttribute('data-product-title') || 'Product';
    var productPrice = btn.getAttribute('data-product-price') || '';
    var productImage = btn.getAttribute('data-product-image') || '';

    if (isDemo || !variantId) {
      addDemoToCart(productTitle, productPrice, productImage, btn, getProductQtyFromBtn(btn), getCartExtrasFromBtn(btn));
      return;
    }

    setCartButtonLoading(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: getProductQtyFromBtn(btn) })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () {
        playAddToCartFeedback(btn);
        updateCartBadge();
        openCartDrawer();
        renderCartDrawer({ animate: true });
      })
      .catch(function () {
        setCartButtonLoading(btn, false);
        window.alert('Could not add this item to your bag. Please try again.');
      });
  });

  if (cartDrawerCheckout) {
    cartDrawerCheckout.addEventListener('click', function (event) {
      if (lastShopifyCart && lastShopifyCart.item_count > 0) {
        event.preventDefault();
        window.location.href = '/checkout';
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
  });

  updateCartBadge();
  renderDemoCartPage();

  function closeAllShopDropdowns(except) {
    document.querySelectorAll('[data-shop-dropdown].is-open, [data-contact-dropdown].is-open').forEach(function (dropdown) {
      if (except && dropdown === except) return;
      var trigger = dropdown.querySelector('.shop-dropdown__trigger');
      var panel = dropdown.querySelector('.shop-dropdown__panel');
      dropdown.classList.remove('is-open', 'is-opening');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initShopDropdowns() {
    document.querySelectorAll('[data-shop-dropdown], [data-contact-dropdown]').forEach(function (dropdown) {
      if (dropdown.dataset.dropdownBound) return;
      dropdown.dataset.dropdownBound = 'true';

      var trigger = dropdown.querySelector('.shop-dropdown__trigger');
      var panel = dropdown.querySelector('.shop-dropdown__panel');
      var valueEl = dropdown.querySelector('[data-shop-dropdown-value]');
      var hiddenInput = dropdown.querySelector('[data-shop-dropdown-input]');
      var options = dropdown.querySelectorAll('.shop-dropdown__option');
      var form = dropdown.closest('form');

      if (!trigger || !panel) return;

      function openPanel() {
        panel.removeAttribute('hidden');
      }

      function closePanel() {
        panel.setAttribute('hidden', '');
      }

      function setValue(value, label) {
        options.forEach(function (opt) {
          var selected = opt.getAttribute('data-value') === value;
          opt.classList.toggle('is-selected', selected);
          opt.setAttribute('aria-selected', selected ? 'true' : 'false');
        });

        if (valueEl) valueEl.textContent = label;
        dropdown.setAttribute('data-value', value);
        if (hiddenInput) hiddenInput.value = value;

        if (dropdown.hasAttribute('data-shop-sort')) {
          dropdown.dispatchEvent(new CustomEvent('shop-sort-change', {
            bubbles: true,
            detail: { value: value, label: label }
          }));
        }

        if (form && dropdown.classList.contains('shop-dropdown--form')) {
          form.submit();
        }
      }

      function openDropdown() {
        closeAllShopDropdowns(dropdown);
        openPanel();
        dropdown.classList.add('is-opening', 'is-open');
        trigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
          dropdown.classList.remove('is-opening');
        });
      }

      function closeDropdown() {
        dropdown.classList.remove('is-open', 'is-opening');
        trigger.setAttribute('aria-expanded', 'false');
        closePanel();
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (dropdown.classList.contains('is-open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });

      options.forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.stopPropagation();
          var value = option.getAttribute('data-value');
          var label = option.querySelector('.shop-dropdown__option-text');
          setValue(value, label ? label.textContent : value);
          closeDropdown();
        });
      });

      window.addEventListener('resize', function () {
        if (dropdown.classList.contains('is-open')) closeDropdown();
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-shop-dropdown]') && !event.target.closest('[data-contact-dropdown]')) {
        closeAllShopDropdowns();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllShopDropdowns();
    });
  }

  initShopDropdowns();

  function initShopPage(shopPage) {
    var perPage = parseInt(shopPage.getAttribute('data-per-page'), 10) || 9;
    var items = Array.prototype.slice.call(shopPage.querySelectorAll('[data-shop-item]'));
    var countEl = shopPage.closest('[data-shop-content]') ? shopPage.closest('[data-shop-content]').querySelector('[data-shop-count]') : shopPage.querySelector('[data-shop-count]');
    var paginationEl = shopPage.closest('[data-shop-content]') ? shopPage.closest('[data-shop-content]').querySelector('[data-shop-pagination]') : shopPage.querySelector('[data-shop-pagination]');
    var noResultsEl = shopPage.closest('[data-shop-content]') ? shopPage.closest('[data-shop-content]').querySelector('[data-shop-no-results]') : shopPage.querySelector('[data-shop-no-results]');
    var sortDropdown = shopPage.querySelector('[data-shop-sort]');
    var filterBtns = shopPage.querySelectorAll('[data-shop-filter]');
    var currentFilter = 'all';
    var currentSort = sortDropdown ? (sortDropdown.getAttribute('data-value') || 'featured') : 'featured';
    var currentPage = 1;

    if (!items.length) return;

    function getPrice(item) {
      return parseInt(item.getAttribute('data-shop-price'), 10) || 0;
    }

    function getFilteredItems() {
      var filtered = items.filter(function (item) {
        if (currentFilter === 'all') return true;
        return item.getAttribute('data-shop-category') === currentFilter;
      });

      if (currentSort === 'price-asc') {
        filtered.sort(function (a, b) { return getPrice(a) - getPrice(b); });
      } else if (currentSort === 'price-desc') {
        filtered.sort(function (a, b) { return getPrice(b) - getPrice(a); });
      }

      return filtered;
    }

    function renderPagination(totalPages) {
      if (!paginationEl) return;
      if (totalPages <= 1) {
        paginationEl.hidden = true;
        paginationEl.innerHTML = '';
        return;
      }

      paginationEl.hidden = false;
      var html = '';

      html += currentPage > 1
        ? '<button type="button" class="shop-pagination__btn" data-shop-page-btn="' + (currentPage - 1) + '" aria-label="Previous page"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 6l-6 6 6 6"/></svg></button>'
        : '<span class="shop-pagination__btn shop-pagination__btn--disabled"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 6l-6 6 6 6"/></svg></span>';

      html += '<div class="shop-pagination__pages">';
      for (var p = 1; p <= totalPages; p += 1) {
        if (p === currentPage) {
          html += '<span class="shop-pagination__page is-current" aria-current="page">' + p + '</span>';
        } else {
          html += '<button type="button" class="shop-pagination__page is-btn" data-shop-page-btn="' + p + '">' + p + '</button>';
        }
      }
      html += '</div>';

      html += currentPage < totalPages
        ? '<button type="button" class="shop-pagination__btn" data-shop-page-btn="' + (currentPage + 1) + '" aria-label="Next page"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg></button>'
        : '<span class="shop-pagination__btn shop-pagination__btn--disabled"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg></span>';

      paginationEl.innerHTML = html;

      paginationEl.querySelectorAll('[data-shop-page-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          currentPage = parseInt(btn.getAttribute('data-shop-page-btn'), 10) || 1;
          render();
          shopPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function render() {
      var visible = getFilteredItems();
      var totalPages = Math.max(1, Math.ceil(visible.length / perPage));

      if (currentPage > totalPages) currentPage = totalPages;

      items.forEach(function (item) {
        item.closest('.shop-grid__item').hidden = true;
      });

      if (!visible.length) {
        if (noResultsEl) noResultsEl.hidden = false;
        if (countEl) countEl.textContent = '0 products';
        renderPagination(0);
        return;
      }

      if (noResultsEl) noResultsEl.hidden = true;
      if (countEl) {
        countEl.textContent = visible.length + (visible.length === 1 ? ' product' : ' products');
      }

      visible.forEach(function (item, index) {
        var page = Math.floor(index / perPage) + 1;
        var wrapper = item.closest('.shop-grid__item');
        var isVisible = page === currentPage;
        wrapper.hidden = !isVisible;
        if (isVisible) {
          var stagger = index % perPage;
          wrapper.style.setProperty('--enter-delay', (stagger * 0.07) + 's');
          wrapper.classList.remove('is-entering');
          void wrapper.offsetWidth;
          wrapper.classList.add('is-entering');
        }
      });

      renderPagination(totalPages);
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        currentFilter = btn.getAttribute('data-shop-filter') || 'all';
        currentPage = 1;
        render();
      });
    });

    if (sortDropdown) {
      sortDropdown.addEventListener('shop-sort-change', function (event) {
        currentSort = event.detail.value || 'featured';
        currentPage = 1;
        render();
      });
    }

    render();
  }

  function initShopPages() {
    document.querySelectorAll('[data-shop-page]').forEach(initShopPage);
  }

  initShopPages();

  function getDemoRoutes() {
    var cfg = window.RJ_CONFIG || {};
    return cfg.routes || window.RJ_ROUTES || { home: '/', shop: '/collections/all' };
  }

  var searchModal = null;
  var searchInput = null;
  var searchResults = null;
  var searchDebounceTimer = null;

  function closeSearchModal() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
  }

  function filterDemoProducts(query) {
    var catalog = getDemoCatalog();
    var q = (query || '').trim().toLowerCase();
    if (!q) return catalog.slice(0, 8);
    return catalog.filter(function (product) {
      var title = (product.title || '').toLowerCase();
      var category = (product.category || '').toLowerCase();
      var handle = (product.handle || '').toLowerCase();
      var description = (product.description || '').toLowerCase();
      return title.indexOf(q) !== -1 ||
        category.indexOf(q) !== -1 ||
        handle.indexOf(q) !== -1 ||
        description.indexOf(q) !== -1;
    }).slice(0, 12);
  }

  function renderSearchResults(query) {
    if (!searchResults) return;
    var products = filterDemoProducts(query);
    var routes = getDemoRoutes();
    var q = (query || '').trim();

    if (!products.length) {
      searchResults.innerHTML = '<p class="search-modal__empty">' +
        (q ? 'No products found for “' + q.replace(/</g, '&lt;') + '”.' : 'No products to show yet.') +
        '</p>';
      return;
    }

    var html = '<ul class="search-modal__results">';
    products.forEach(function (product) {
      var imageUrl = product.image || '';
      var link = product.url || (routes.shop + '?product=' + encodeURIComponent(product.handle));
      var category = product.category ? product.category.charAt(0).toUpperCase() + product.category.slice(1) : '';
      html +=
        '<li>' +
          '<a class="search-modal__result" href="' + link + '">' +
            '<div class="search-modal__result-image">' +
              (image ? '<img src="' + imageUrl + '" alt="" width="52" height="52" loading="lazy">' : '') +
            '</div>' +
            '<div class="search-modal__result-info">' +
              '<p class="search-modal__result-title">' + product.title + '</p>' +
              '<p class="search-modal__result-meta">' + category + '</p>' +
            '</div>' +
            '<span class="search-modal__result-price">' + (product.price || '') + '</span>' +
          '</a>' +
        '</li>';
    });
    html += '</ul>';
    searchResults.innerHTML = html;
  }

  function openSearchModal() {
    if (!searchModal) return;
    closeCartDrawer();
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    lockPageScroll();
    if (searchInput) {
      searchInput.value = '';
      renderSearchResults('');
      window.setTimeout(function () { searchInput.focus(); }, 80);
    }
  }

  function initSearchModal() {
    searchModal = document.querySelector('[data-search-modal]');
    if (!searchModal) return;
    searchInput = searchModal.querySelector('[data-search-input]');
    searchResults = searchModal.querySelector('[data-search-results]');

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounceTimer);
        var value = searchInput.value;
        searchDebounceTimer = setTimeout(function () {
          renderSearchResults(value);
        }, 150);
      });

      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeSearchModal();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSearchModal();
    });
  }

  function getAssetBase() {
    var cfg = window.RJ_CONFIG || {};
    if (cfg.assetSample) {
      return cfg.assetSample.replace(/logo\.png(\?.*)?$/, '').replace(/product-star-anklet\.png(\?.*)?$/, '');
    }
    var productRoot = document.getElementById('rj-product-root');
    if (productRoot) {
      var sampleAsset = productRoot.getAttribute('data-sample-asset') || '';
      return sampleAsset.replace(/logo\.png(\?.*)?$/, '').replace(/product-star-anklet\.png(\?.*)?$/, '');
    }
    return '';
  }

  function resolveProductImage(image, assetBase) {
    var img = (image || '').trim();
    if (/^https?:\/\//i.test(img)) return img;
    return (assetBase || '') + (img || 'logo.png');
  }

  function getDemoCatalog() {
    var el = document.getElementById('rj-demo-catalog');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function normalizeHandle(slug) {
    if (!slug) return '';
    try {
      slug = decodeURIComponent(slug);
    } catch (e) {}
    return slug.toLowerCase().trim();
  }

  function findDemoProduct(handle) {
    var slug = normalizeHandle(handle);
    if (!slug) return null;
    return getDemoCatalog().find(function (p) {
      return normalizeHandle(p.handle) === slug;
    }) || null;
  }

  function renderDemoProductInto(mountEl, handle) {
    if (!mountEl) return false;
    var product = findDemoProduct(handle);
    if (!product) return false;

    mountEl.innerHTML = buildDemoProductHtml(product, getAssetBase());
    mountEl.hidden = false;
    mountEl.removeAttribute('hidden');
    mountEl.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    document.title = product.title + ' – ' + SHOP_NAME;
    initProductPage(mountEl);
    initViewerBadge(mountEl);
    initRelatedSection(mountEl);
    return true;
  }

  function initDemoProductView() {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('product');
    if (!handle) return;

    var productView = document.getElementById('rj-product-view');
    if (!productView) return;
    if (!renderDemoProductInto(productView, handle)) return;

    var shopContent = document.querySelector('[data-shop-content]');
    var shopHero = document.querySelector('.shop-hero');
    if (shopContent) shopContent.hidden = true;
    if (shopHero) shopHero.hidden = true;
    window.scrollTo(0, 0);
  }

  function init404Router() {
    var virtualRoot = document.getElementById('rj-virtual-pages');
    var productRoot = document.getElementById('rj-product-root');
    var fallback = document.getElementById('rj-fallback-404');
    if (!fallback) return;

    var path = window.location.pathname.toLowerCase();

    if (path.indexOf('/products/') !== -1 && productRoot) {
      var slug = path.split('/products/')[1].split('/')[0].split('?')[0];
      if (!slug) return;

      if (renderDemoProductInto(productRoot, slug)) {
        fallback.hidden = true;
      }
      return;
    }

    if (!virtualRoot) return;

    var pageSlug = '';
    if (path.indexOf('/pages/') !== -1) {
      pageSlug = path.split('/pages/')[1].split('/')[0].split('?')[0];
    } else {
      pageSlug = path.replace(/^\//, '').split('/')[0].split('?')[0];
    }

    var knownPages = { about: 1, faq: 1, terms: 1, privacy: 1, shipping: 1, refund: 1, contact: 1, checkout: 1, payment: 1, account: 1 };
    if (!knownPages[pageSlug]) return;

    var page = document.querySelector('[data-rj-page="' + pageSlug + '"]');
    if (!page) return;

    virtualRoot.hidden = false;
    page.hidden = false;
    fallback.hidden = true;

    var titles = {
      about: 'About Us',
      faq: 'FAQ',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      shipping: 'Shipping Policy',
      refund: 'Refund & Exchange',
      contact: 'Contact Us',
      checkout: 'Checkout',
      payment: 'Payment Instructions',
      account: 'My Account'
    };
    if (titles[pageSlug]) document.title = titles[pageSlug] + ' – ' + SHOP_NAME;

    if (pageSlug === 'checkout') {
      initCheckoutPage(page);
    } else if (pageSlug === 'payment') {
      initPaymentTutorialPage(page);
    } else if (pageSlug === 'account') {
      initAccountPage(page);
    }
  }

  function getViewerCount(product) {
    var tiers = {
      rings: 14, bracelets: 22, earrings: 28, necklaces: 24,
      anklets: 18, pendants: 20, sets: 45
    };
    var base = tiers[product.category] || 18;
    var hash = 0;
    var str = product.handle || product.title || '';
    for (var i = 0; i < str.length; i++) hash += str.charCodeAt(i);
    var fameBoost = Math.floor((product.price_value || 1500) / 800);
    return Math.min(156, base + (hash % 31) + fameBoost);
  }

  function buildViewerBadgeHtml(product) {
    var count = getViewerCount(product);
    return (
      '<div class="product-page__viewing" data-product-viewers data-viewer-base="' + count + '">' +
        '<span class="product-page__viewing-eye" aria-hidden="true">👁</span>' +
        '<span class="product-page__viewing-count">' + count + '</span>' +
        '<span class="product-page__viewing-text">people are viewing this right now</span>' +
      '</div>'
    );
  }

  function initViewerBadge(root) {
    var el = (root || document).querySelector('[data-product-viewers]');
    if (!el || el.dataset.viewerReady) return;
    el.dataset.viewerReady = 'true';

    var countEl = el.querySelector('.product-page__viewing-count');
    var base = parseInt(el.getAttribute('data-viewer-base'), 10) || 18;

    function tick() {
      var delta = Math.floor(Math.random() * 5) - 2;
      base = Math.max(6, Math.min(160, base + delta));
      if (countEl) countEl.textContent = base;
    }

    tick();
    window.setInterval(tick, 3500 + Math.floor(Math.random() * 2500));
  }

  function buildWhatsAppUrl(title, price, qty, giftWrap) {
    var cfg = window.RJ_CONFIG || {};
    var wa = cfg.whatsapp || {};
    var number = (wa.number || '923045833352').replace(/\D/g, '');
    var msg = 'Hi ' + SHOP_NAME + '! I would like to order:\n' + title + ' x' + qty + ' — ' + price;
    if (giftWrap) msg += '\n🎁 Gift wrapping requested';
    return 'https://wa.me/' + number + '?text=' + encodeURIComponent(msg);
  }

  function buildRelatedProductsHtml(product, assetBase, routes) {
    var related = getDemoCatalog().filter(function (p) {
      return p.category === product.category && p.handle !== product.handle;
    }).slice(0, 4);

    if (!related.length) return '';

    var cards = related.map(function (item) {
      var img = resolveProductImage(item.image, assetBase);
      var link = routes.shop + '?product=' + item.handle;
      var compare = item.compare_at_price
        ? '<span class="product-related__compare">' + item.compare_at_price + '</span>'
        : '';
      return (
        '<a href="' + link + '" class="product-related__card">' +
          '<div class="product-related__image">' +
            '<img src="' + img + '" alt="' + item.title + '" width="400" height="400" loading="lazy">' +
          '</div>' +
          '<p class="product-related__name">' + item.title + '</p>' +
          '<p class="product-related__prices">' + compare +
            '<span class="product-related__price">' + item.price + '</span>' +
          '</p>' +
        '</a>'
      );
    }).join('');

    return (
      '<section class="product-related reveal" data-related-products>' +
        '<div class="container">' +
          '<h2 class="product-related__title">You May Also Like</h2>' +
          '<p class="product-related__subtitle">More from our ' + product.category + ' collection</p>' +
          '<div class="product-related__grid">' + cards + '</div>' +
        '</div>' +
      '</section>'
    );
  }

  function initRelatedSection(root) {
    var section = (root || document).querySelector('[data-related-products]');
    if (!section || section.dataset.relatedReady) return;
    section.dataset.relatedReady = 'true';

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      obs.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  }

  function getProductImages(product) {
    if (product.images && product.images.length) return product.images;
    var fallback = product.image || 'logo.png';
    return [fallback, fallback, fallback];
  }

  function getProductColors(product) {
    if (product.colors && product.colors.length) return product.colors;
    var images = getProductImages(product);
    return [
      { id: 'silver', name: 'Silver', image: images[0] },
      { id: 'gold', name: 'Gold', image: images[1] || images[0] },
      { id: 'rose-gold', name: 'Rose Gold', image: images[2] || images[0] }
    ];
  }

  function showProductImage(gallery, index) {
    if (!gallery) return;
    var idx = String(index);
    gallery.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      var active = thumb.getAttribute('data-index') === idx;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    gallery.querySelectorAll('[data-product-main-img]').forEach(function (img) {
      img.classList.toggle('is-hidden', img.getAttribute('data-index') !== idx);
    });
  }

  function buildProductGalleryHtml(product, assetBase) {
    var images = getProductImages(product);
    var title = product.title || 'Product';
    var mainImgs = images.map(function (img, i) {
      var url = assetBase + img;
      return (
        '<img class="product-page__main-img' + (i === 0 ? '' : ' is-hidden') + '" src="' + url + '" alt="' + title + '" width="1200" height="1200" loading="' + (i === 0 ? 'eager' : 'lazy') + '" data-product-main-img data-index="' + i + '">'
      );
    }).join('');

    var thumbs = images.map(function (img, i) {
      var url = assetBase + img;
      return (
        '<button type="button" class="product-page__thumb' + (i === 0 ? ' is-active' : '') + '" data-product-thumb data-index="' + i + '" aria-label="View image ' + (i + 1) + '" aria-selected="' + (i === 0 ? 'true' : 'false') + '">' +
          '<img src="' + url + '" alt="" width="72" height="72" loading="lazy">' +
        '</button>'
      );
    }).join('');

    return (
      '<div class="product-page__gallery" data-product-gallery>' +
        '<div class="product-page__main">' + mainImgs + '</div>' +
        '<div class="product-page__thumbs" role="tablist" aria-label="Product images">' + thumbs + '</div>' +
      '</div>'
    );
  }

  function buildColorSelectHtml(product) {
    var colors = getProductColors(product);
    var buttons = colors.map(function (color, i) {
      var swatchClass = 'product-page__color-swatch product-page__color-swatch--' + color.id;
      return (
        '<button type="button" class="product-page__color-option' + (i === 0 ? ' is-active' : '') + '" data-color="' + color.id + '" data-color-index="' + i + '" aria-selected="' + (i === 0 ? 'true' : 'false') + '">' +
          '<span class="' + swatchClass + '" aria-hidden="true"></span>' +
          '<span class="product-page__color-name">' + color.name + '</span>' +
        '</button>'
      );
    }).join('');

    return (
      '<div class="product-page__colors" data-product-colors>' +
        '<p class="product-page__colors-label">Color</p>' +
        '<div class="product-page__color-options" role="listbox" aria-label="Color">' + buttons + '</div>' +
      '</div>'
    );
  }

  function applyShopifyVariant(root, opt) {
    if (!opt || !root) return;

    var hidden = root.querySelector('[data-product-variant-id]');
    var addBtn = root.querySelector('.product-page__add[data-add-to-cart]');
    var buyBtn = root.querySelector('.product-page__buy-now[data-buy-now]');
    var priceEl = root.querySelector('.product-page__price');
    var compareEl = root.querySelector('.product-page__compare');
    var stockEl = root.querySelector('[data-product-stock]');
    var waLink = root.querySelector('[data-order-whatsapp]');
    var available = opt.getAttribute('data-available') !== 'false';
    var priceText = opt.getAttribute('data-price') || '';

    if (hidden) hidden.value = opt.value;
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', opt.value);
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
    }
    if (buyBtn) {
      buyBtn.setAttribute('data-variant-id', opt.value);
      buyBtn.disabled = !available;
    }
    if (priceEl && priceText) priceEl.textContent = priceText;
    if (waLink && priceText) {
      waLink.setAttribute('data-product-price', priceText);
      var qtyInput = root.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var giftWrap = getGiftWrapSelection(root).selected;
      waLink.href = buildWhatsAppUrl(
        waLink.getAttribute('data-product-title') || '',
        priceText,
        qty,
        giftWrap
      );
    }
    if (compareEl) {
      var compareVal = opt.getAttribute('data-compare');
      compareEl.textContent = compareVal || '';
      compareEl.style.display = compareVal ? '' : 'none';
    }
    if (stockEl) {
      var inv = parseInt(opt.getAttribute('data-inventory'), 10);
      stockEl.className = 'product-page__stock';
      var textNode = stockEl.childNodes[stockEl.childNodes.length - 1];
      if (!available) {
        stockEl.classList.add('is-sold-out');
        if (textNode) textNode.textContent = ' Out of stock!';
      } else if (inv > 0 && inv <= 5) {
        stockEl.classList.add('is-low-stock');
        if (textNode) textNode.textContent = ' Only ' + inv + ' left';
      } else if (inv > 0) {
        stockEl.classList.add('is-in-stock');
        if (textNode) textNode.textContent = ' ' + inv + ' in stock';
      } else {
        stockEl.classList.add('is-in-stock');
        if (textNode) textNode.textContent = ' In stock';
      }
    }
  }

  function initProductColors(root) {
    var colorsRoot = (root || document).querySelector('[data-product-colors]');
    if (!colorsRoot || colorsRoot.dataset.colorsBound) return;
    colorsRoot.dataset.colorsBound = 'true';

    var detailsRoot = colorsRoot.closest('.product-page__details') || root;
    var gallery = (root || document).querySelector('[data-product-gallery]');
    var variantSelect = detailsRoot ? detailsRoot.querySelector('[data-product-variant-select]') : null;

    colorsRoot.querySelectorAll('[data-color]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var variantId = btn.getAttribute('data-variant-id');
        colorsRoot.querySelectorAll('[data-color]').forEach(function (opt) {
          var active = opt === btn;
          opt.classList.toggle('is-active', active);
          opt.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (variantSelect && variantId) {
          variantSelect.value = variantId;
          applyShopifyVariant(detailsRoot, variantSelect.options[variantSelect.selectedIndex]);
        }

        if (gallery) {
          showProductImage(gallery, btn.getAttribute('data-color-index') || '0');
        }
      });
    });
  }

  function buildDemoProductHtml(product, assetBase) {
    var routes = getDemoRoutes();
    var imageUrl = resolveProductImage(product.image, assetBase);
    var stockClass = product.in_stock ? 'is-in-stock' : 'is-sold-out';
    var stockText = product.in_stock ? (product.stock + ' in stock') : 'Out of stock!';
    var compareHtml = product.compare_at_price
      ? '<span class="product-page__compare">' + product.compare_at_price + '</span>'
      : '';
    var waUrl = buildWhatsAppUrl(product.title, product.price, 1);
    var btnAttrs =
      ' data-product-title="' + product.title.replace(/"/g, '&quot;') + '"' +
      ' data-product-price="' + product.price + '"' +
      ' data-product-image="' + imageUrl + '"';

    return (
      '<section class="product-page">' +
        '<div class="container product-page__wrap">' +
          '<nav class="product-breadcrumb shop-breadcrumb reveal" aria-label="Breadcrumb">' +
            '<a href="' + routes.home + '">Home</a><span aria-hidden="true">/</span>' +
            '<a href="' + routes.shop + '">Shop</a><span aria-hidden="true">/</span>' +
            '<span>' + product.title + '</span>' +
          '</nav>' +
          '<div class="product-page__grid reveal anim-delay-1">' +
            buildProductGalleryHtml(product, assetBase) +
            '<div class="product-page__details" data-product-category="' + (product.category || '') + '">' +
              buildViewerBadgeHtml(product) +
              '<h1 class="product-page__title">' + product.title + '</h1>' +
              '<div class="product-page__prices">' + compareHtml +
                '<span class="product-page__price">' + product.price + '</span>' +
              '</div>' +
              '<p class="product-page__stock ' + stockClass + '" data-product-stock>' +
                '<span class="product-page__stock-dot" aria-hidden="true"></span>' + stockText +
              '</p>' +
              buildColorSelectHtml(product) +
              '<ul class="product-page__meta">' +
                '<li><strong>Material:</strong> ' + (product.material || 'Stainless steel') + '</li>' +
                '<li><strong>Category:</strong> ' + product.category + '</li>' +
                '<li><strong>Shipping:</strong> Free across Pakistan</li>' +
                '<li><strong>Delivery:</strong> 3–5 business days</li>' +
              '</ul>' +
              buildGiftWrapHtml(product) +
              '<div class="product-page__actions">' +
                '<div class="product-page__qty" data-product-qty>' +
                  '<button type="button" class="product-page__qty-btn" data-qty-minus aria-label="Decrease quantity">−</button>' +
                  '<input type="number" value="1" min="1" max="99" class="product-page__qty-input" data-qty-input aria-label="Quantity" readonly>' +
                  '<button type="button" class="product-page__qty-btn" data-qty-plus aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<div class="product-page__cta-row">' +
                  '<button type="button" class="btn-shop product-page__add" data-add-to-cart data-demo-cart="true"' + btnAttrs +
                    (product.in_stock ? '' : ' disabled') + '>' +
                    (product.in_stock ? 'Add to Bag' : 'Sold Out') +
                  '</button>' +
                  '<button type="button" class="btn-shop product-page__buy-now" data-buy-now data-demo-cart="true"' + btnAttrs +
                    (product.in_stock ? '' : ' disabled') + '>Buy Now</button>' +
                '</div>' +
                '<a class="product-page__whatsapp" data-order-whatsapp' +
                  ' data-product-title="' + product.title.replace(/"/g, '&quot;') + '"' +
                  ' data-product-price="' + product.price + '"' +
                  ' href="' + waUrl + '" target="_blank" rel="noopener"' +
                  (product.in_stock ? '' : ' aria-disabled="true" tabindex="-1"') + '>' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
                  'Order on WhatsApp' +
                '</a>' +
              '</div>' +
              '<div class="product-page__trust">' +
                '<div class="product-page__trust-item"><span>Quality stainless steel</span></div>' +
                '<div class="product-page__trust-item"><span>Free shipping</span></div>' +
                '<div class="product-page__trust-item"><span>Secure payment</span></div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</section>' +
      buildRelatedProductsHtml(product, assetBase, routes)
    );
  }

  function initProductPage(scope) {
    var root = scope || document;
    var gallery = root.querySelector ? root.querySelector('[data-product-gallery]') : null;
    if (gallery && !gallery.dataset.galleryBound) {
      gallery.dataset.galleryBound = 'true';
      gallery.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showProductImage(gallery, thumb.getAttribute('data-index'));
          var colorsRoot = root.querySelector('[data-product-colors]');
          if (colorsRoot) {
            var idx = thumb.getAttribute('data-index');
            colorsRoot.querySelectorAll('[data-color]').forEach(function (opt) {
              var active = opt.getAttribute('data-color-index') === idx;
              opt.classList.toggle('is-active', active);
              opt.setAttribute('aria-selected', active ? 'true' : 'false');
            });
          }
        });
      });
    }

    initProductColors(root);

    var qtyRoots = root.querySelectorAll ? root.querySelectorAll('[data-product-qty]') : [];
    qtyRoots.forEach(function (wrap) {
      if (wrap.dataset.qtyBound) return;
      wrap.dataset.qtyBound = 'true';

      var input = wrap.querySelector('[data-qty-input]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;

      var detailsRoot = wrap.closest('.product-page__details') || root;
      var waLink = detailsRoot ? detailsRoot.querySelector('[data-order-whatsapp]') : null;

      function updateWhatsAppLink() {
        if (!waLink) return;
        var title = waLink.getAttribute('data-product-title') || '';
        var price = waLink.getAttribute('data-product-price') || '';
        var qty = parseInt(input.value, 10) || 1;
        var giftWrap = getGiftWrapSelection(detailsRoot).selected;
        waLink.href = buildWhatsAppUrl(title, price, qty, giftWrap);
      }

      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
        updateWhatsAppLink();
      });
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.min(99, val + 1);
        updateWhatsAppLink();
      });

      updateWhatsAppLink();
    });

    root.querySelectorAll('[data-product-gift-wrap]').forEach(function (checkbox) {
      if (checkbox.dataset.giftBound) return;
      checkbox.dataset.giftBound = 'true';
      var detailsRoot = checkbox.closest('.product-page__details') || root;
      var waLink = detailsRoot.querySelector('[data-order-whatsapp]');
      var qtyInput = detailsRoot.querySelector('[data-qty-input]');

      checkbox.addEventListener('change', function () {
        checkbox.closest('.product-page__gift-wrap').classList.toggle('is-checked', checkbox.checked);
        if (!waLink) return;
        var title = waLink.getAttribute('data-product-title') || '';
        var price = waLink.getAttribute('data-product-price') || '';
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        waLink.href = buildWhatsAppUrl(title, price, qty, checkbox.checked);
      });
    });

    initViewerBadge(root);
    initRelatedSection(root);

    var variantSelect = root.querySelector ? root.querySelector('[data-product-variant-select]') : null;
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var detailsRoot = variantSelect.closest('.product-page__details') || root;
        var opt = variantSelect.options[variantSelect.selectedIndex];
        applyShopifyVariant(detailsRoot, opt);

        var colorsRoot = detailsRoot.querySelector('[data-product-colors]');
        if (colorsRoot && opt) {
          colorsRoot.querySelectorAll('[data-color]').forEach(function (colorBtn) {
            var active = colorBtn.getAttribute('data-variant-id') === opt.value;
            colorBtn.classList.toggle('is-active', active);
            colorBtn.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }
      });
    }
  }

  function initCheckoutPage(scope) {
    var root = scope || document.querySelector('[data-checkout-page]');
    if (!root || root.dataset.checkoutReady) return;
    root.dataset.checkoutReady = 'true';

    var configEl = root.querySelector('[data-checkout-config]');
    var config = { advanceAmount: 300, whatsappNumber: '923045833352' };
    if (configEl) {
      try { config = JSON.parse(configEl.textContent); } catch (e) {}
    }

    var emptyEl = root.querySelector('[data-checkout-empty]');
    var layoutEl = root.querySelector('[data-checkout-layout]');
    var itemsEl = root.querySelector('[data-checkout-items]');
    var subtotalEl = root.querySelector('[data-checkout-subtotal]');
    var totalEl = root.querySelector('[data-checkout-total]');
    var advanceRow = root.querySelector('[data-checkout-advance-row]');
    var advanceEl = root.querySelector('[data-checkout-advance]');
    var codBalanceRow = root.querySelector('[data-checkout-cod-balance]');
    var codBalanceEl = root.querySelector('[data-checkout-cod-balance-amount]');
    var form = root.querySelector('[data-checkout-form]');
    var advanceAmount = parseInt(config.advanceAmount, 10) || 300;
    var lastSubtotal = 0;
    var lastShopifyCart = null;

    function getShopifySubtotal(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.reduce(function (sum, item) {
        return sum + item.final_line_price / 100;
      }, 0);
    }

    function buildShopifyLines(cart) {
      if (!cart || !cart.items) return '';
      return cart.items.map(function (item) {
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? ' (' + item.variant_title + ')'
          : '';
        return '• ' + item.product_title + variant + ' x' + item.quantity + ' — ' + formatMoney(item.final_line_price);
      }).join('\n');
    }

    function renderSummary(demoItems, shopifyCart) {
      var html = '';
      var subtotal = 0;

      if (shopifyCart && shopifyCart.items) {
        shopifyCart.items.forEach(function (item) {
          subtotal += item.final_line_price / 100;
          html +=
            '<div class="checkout-summary__item">' +
              '<div class="checkout-summary__item-image">' +
                (item.image ? '<img src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' : '') +
              '</div>' +
              '<div class="checkout-summary__item-info">' +
                '<p class="checkout-summary__item-title">' + item.product_title + '</p>' +
                '<p class="checkout-summary__item-meta">Qty ' + item.quantity + ' · ' + formatMoney(item.final_price) + '</p>' +
              '</div>' +
            '</div>';
        });
      }

      demoItems.forEach(function (item) {
        var unit = item.priceValue || parsePkrPrice(item.price);
        var line = unit * (item.qty || 1);
        var giftFee = item.giftWrap && !isGiftWrapFree(item.category) ? GIFT_WRAP_PRICE : 0;
        line += giftFee;
        subtotal += line;
        var giftMeta = item.giftWrap
          ? ' · 🎁 Gift wrap' + (giftFee ? ' (+Rs. ' + giftFee + ')' : ' (Free)')
          : '';
        html +=
          '<div class="checkout-summary__item">' +
            '<div class="checkout-summary__item-image">' +
              (item.image ? '<img src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' : '<div class="checkout-summary__item-ph"></div>') +
            '</div>' +
            '<div class="checkout-summary__item-info">' +
              '<p class="checkout-summary__item-title">' + item.title + '</p>' +
              '<p class="checkout-summary__item-meta">Qty ' + (item.qty || 1) + ' · ' + item.price + giftMeta + '</p>' +
            '</div>' +
          '</div>';
      });

      if (itemsEl) itemsEl.innerHTML = html;
      if (subtotalEl) subtotalEl.textContent = formatPkrAmount(subtotal);
      if (totalEl) totalEl.textContent = formatPkrAmount(subtotal);
      lastSubtotal = subtotal;
      updateAdvanceVisibility();
      return subtotal;
    }

    function updateAdvanceVisibility() {
      if (!form) return;
      var payment = form.querySelector('input[name="payment"]:checked');
      var isCod = payment && payment.value === 'COD';
      if (advanceRow) advanceRow.hidden = false;
      if (advanceEl) advanceEl.textContent = 'Rs. ' + advanceAmount.toLocaleString('en-PK');
      if (codBalanceRow) {
        codBalanceRow.hidden = !isCod;
        if (codBalanceEl && isCod) {
          var balance = Math.max(0, lastSubtotal - advanceAmount);
          codBalanceEl.textContent = formatPkrAmount(balance);
        }
      }
    }

    function loadCheckout() {
      var demoItems = getDemoCart();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (shopifyCart) {
          var hasDemo = demoItems.length > 0;
          var hasShopify = shopifyCart.item_count > 0;

          if (!hasDemo && !hasShopify) {
            if (emptyEl) emptyEl.hidden = false;
            if (layoutEl) layoutEl.hidden = true;
            lastShopifyCart = null;
            return;
          }

          if (emptyEl) emptyEl.hidden = true;
          lastShopifyCart = hasShopify ? shopifyCart : null;
          if (layoutEl) layoutEl.hidden = false;
          renderSummary(demoItems, hasShopify ? shopifyCart : null);
          updateAdvanceVisibility();
        })
        .catch(function () {
          if (!demoItems.length) {
            if (emptyEl) emptyEl.hidden = false;
            if (layoutEl) layoutEl.hidden = true;
            return;
          }
          if (emptyEl) emptyEl.hidden = true;
          if (layoutEl) layoutEl.hidden = false;
          renderSummary(demoItems, null);
          updateAdvanceVisibility();
        });
    }

    if (form) {
      form.querySelectorAll('input[name="payment"]').forEach(function (radio) {
        radio.addEventListener('change', updateAdvanceVisibility);
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var submitBtn = root.querySelector('[data-checkout-submit]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Placing order…';
        }

        var demoItems = getDemoCart();
        var shopifyItems = lastShopifyCart && lastShopifyCart.items ? lastShopifyCart.items : [];
        if (!demoItems.length && !shopifyItems.length) return;

        var data = new FormData(form);
        var name = data.get('name');
        var phone = data.get('phone');
        var email = data.get('email') || '';
        var city = data.get('city');
        var address = data.get('address');
        var notes = data.get('notes') || '';
        var payment = data.get('payment') || 'COD';
        var demoSubtotal = getDemoSubtotal(demoItems);
        var shopifySubtotal = getShopifySubtotal(lastShopifyCart);
        var subtotal = demoSubtotal + shopifySubtotal;
        var orderId = 'RJ-' + Date.now().toString().slice(-6);

        var lines = [];
        if (shopifyItems.length) {
          lines.push(buildShopifyLines(lastShopifyCart));
        }
        if (demoItems.length) {
          lines.push(demoItems.map(function (item) {
            var giftNote = '';
            if (item.giftWrap) {
              giftNote = isGiftWrapFree(item.category) ? ' [🎁 Gift wrap - Free]' : ' [🎁 Gift wrap - Rs. ' + GIFT_WRAP_PRICE + ']';
            }
            return '• ' + item.title + ' x' + (item.qty || 1) + giftNote + ' — ' + item.price;
          }).join('\n'));
        }
        var itemsText = lines.filter(Boolean).join('\n');

        var msg =
          'Hi ' + SHOP_NAME + '! New order:\n\n' +
          'Order: ' + orderId + '\n' +
          'Name: ' + name + '\n' +
          'Phone: ' + phone + '\n' +
          (email ? 'Email: ' + email + '\n' : '') +
          'City: ' + city + '\n' +
          'Address: ' + address + '\n' +
          'Payment: ' + payment + '\n' +
          'Advance (pay online): Rs. ' + advanceAmount + '\n' +
          (payment === 'COD' ? 'Balance due on delivery: ' + formatPkrAmount(Math.max(0, subtotal - advanceAmount)) + '\n' : '') +
          (notes ? 'Notes: ' + notes + '\n' : '') +
          '\nItems:\n' + itemsText + '\n\n' +
          'Subtotal: ' + formatPkrAmount(subtotal) + '\n' +
          'Shipping: Free\n\n' +
          'I will send my Rs. ' + advanceAmount + ' advance payment screenshot shortly.';

        var waUrl = 'https://wa.me/' + (config.whatsappNumber || '923045833352') + '?text=' + encodeURIComponent(msg);
        var paymentUrl = config.paymentUrl || '/pages/payment';

        function finishOrder() {
          try {
            sessionStorage.setItem('royalJewellsPendingOrder', JSON.stringify({
              orderId: orderId,
              waUrl: waUrl,
              payment: payment,
              advanceAmount: advanceAmount
            }));
            saveOrderToHistory({
              orderId: orderId,
              email: email,
              name: name,
              phone: phone,
              city: city,
              address: address,
              payment: payment,
              subtotal: subtotal,
              advanceAmount: advanceAmount,
              itemCount: demoItems.length + shopifyItems.length,
              createdAt: Date.now()
            });
            notifyMerchantOfOrder({
              orderId: orderId,
              name: name,
              phone: phone,
              email: email,
              city: city,
              address: address,
              payment: payment,
              notes: notes,
              subtotal: subtotal,
              advanceAmount: advanceAmount,
              itemsText: itemsText
            });
          } catch (e) {}

          saveDemoCart([]);
          lastShopifyCart = null;
          updateCartBadge();
          var paymentQuery =
            '?order=' + encodeURIComponent(orderId) +
            '&payment=' + encodeURIComponent(payment);
          window.location.href = paymentUrl + paymentQuery;
        }

        if (shopifyItems.length) {
          fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
          }).then(finishOrder).catch(finishOrder);
          return;
        }

        finishOrder();
      });
    }

    loadCheckout();
  }

  function normalizeEmail(email) {
    return String(email || '').trim().toLowerCase();
  }

  var PENDING_ORDER_KEY = 'royalJewellsPendingOrder';
  var DELIVERY_PREFS_KEY = 'royalJewellsDeliveryPrefs';

  function getDeliveryPrefs(email) {
    try {
      var all = JSON.parse(window.localStorage.getItem(DELIVERY_PREFS_KEY) || '{}');
      return all[normalizeEmail(email)] || null;
    } catch (e) {
      return null;
    }
  }

  function saveDeliveryPrefs(email, prefs) {
    try {
      var all = JSON.parse(window.localStorage.getItem(DELIVERY_PREFS_KEY) || '{}');
      all[normalizeEmail(email)] = prefs;
      window.localStorage.setItem(DELIVERY_PREFS_KEY, JSON.stringify(all));
    } catch (e) {}
  }

  function renderWebsiteOrderHistory(root, email) {
    var wrap = root.querySelector('[data-account-website-orders]');
    var listEl = root.querySelector('[data-account-orders-list]');
    if (!wrap || !listEl) return;

    var orders = getOrderHistory().filter(function (order) {
      return !order.email || normalizeEmail(order.email) === normalizeEmail(email);
    });

    if (!orders.length) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var html = '<ul class="account-orders__list">';
    orders.forEach(function (order) {
      var date = order.createdAt
        ? new Date(order.createdAt).toLocaleDateString('en-PK', { day: 'numeric', month: 'short', year: 'numeric' })
        : '';
      html +=
        '<li class="account-orders__item">' +
          '<div class="account-orders__item-head">' +
            '<strong>' + (order.orderId || 'Order') + '</strong>' +
            '<span>' + (order.subtotal ? formatPkrAmount(order.subtotal) : '') + '</span>' +
          '</div>' +
          '<p class="account-orders__item-meta">' +
            (date ? date + ' · ' : '') +
            (order.payment || 'Pending') +
          '</p>' +
          '<a class="account-orders__item-link" href="/pages/payment?order=' + encodeURIComponent(order.orderId || '') + '">Payment instructions</a>' +
        '</li>';
    });
    html += '</ul>';
    listEl.innerHTML = html;
  }

  function initAccountPage(scope) {
    var root = scope || document.querySelector('[data-account-page]');
    if (!root || root.dataset.accountReady) return;
    root.dataset.accountReady = 'true';

    root.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });

    var shopifyRoot = root.querySelector('[data-account-shopify]');
    if (!shopifyRoot) return;

    var email = shopifyRoot.getAttribute('data-customer-email') || '';
    var extrasForm = root.querySelector('[data-account-extras-form]');
    var saveSuccess = root.querySelector('[data-account-save-success]');
    var prefs = getDeliveryPrefs(email);

    if (prefs) {
      var phoneEl = root.querySelector('[data-account-edit-phone]');
      var cityEl = root.querySelector('[data-account-edit-city]');
      var addressEl = root.querySelector('[data-account-edit-address]');
      if (phoneEl && prefs.phone) phoneEl.value = prefs.phone;
      if (cityEl && prefs.city) cityEl.value = prefs.city;
      if (addressEl && prefs.address) addressEl.value = prefs.address;
    }

    if (extrasForm) {
      extrasForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var phoneInput = root.querySelector('[data-account-edit-phone]');
        var cityInput = root.querySelector('[data-account-edit-city]');
        var addressInput = root.querySelector('[data-account-edit-address]');
        saveDeliveryPrefs(email, {
          phone: phoneInput && phoneInput.value ? phoneInput.value.trim() : '',
          city: cityInput && cityInput.value ? cityInput.value.trim() : '',
          address: addressInput && addressInput.value ? addressInput.value.trim() : '',
          updatedAt: Date.now()
        });
        if (saveSuccess) {
          saveSuccess.hidden = false;
          window.setTimeout(function () { saveSuccess.hidden = true; }, 2500);
        }
      });
    }

    renderWebsiteOrderHistory(root, email);
  }

  var ORDER_HISTORY_KEY = 'royalJewellsOrderHistory';

  function getOrderHistory() {
    try {
      return JSON.parse(window.localStorage.getItem(ORDER_HISTORY_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveOrderToHistory(order) {
    var history = getOrderHistory();
    history.unshift(order);
    window.localStorage.setItem(ORDER_HISTORY_KEY, JSON.stringify(history.slice(0, 50)));
  }

  function notifyMerchantOfOrder(details) {
    var customerEmail = details.email;
    if (!customerEmail) {
      var digits = String(details.phone || '').replace(/\D/g, '');
      customerEmail = digits ? 'customer-' + digits + '@orders.royaljewells' : 'website-customer@orders.royaljewells';
    }

    var body =
      'NEW ORDER ON HAAM STYLES WEBSITE\n\n' +
      'Order ID: ' + details.orderId + '\n' +
      'Name: ' + details.name + '\n' +
      'Phone / WhatsApp: ' + details.phone + '\n' +
      (details.email ? 'Email: ' + details.email + '\n' : '') +
      'City: ' + details.city + '\n' +
      'Address: ' + details.address + '\n' +
      'Payment method: ' + details.payment + '\n' +
      'Advance due now: Rs. ' + details.advanceAmount + '\n' +
      (details.payment === 'COD' ? 'Balance on delivery: ' + formatPkrAmount(Math.max(0, details.subtotal - details.advanceAmount)) + '\n' : '') +
      (details.notes ? 'Customer notes: ' + details.notes + '\n' : '') +
      '\nItems:\n' + details.itemsText + '\n\n' +
      'Subtotal: ' + formatPkrAmount(details.subtotal) + '\n' +
      'Shipping: Free\n\n' +
      'Customer was sent to the payment page. Watch WhatsApp for their Rs. ' + details.advanceAmount + ' advance screenshot.';

    var params = new URLSearchParams({
      form_type: 'contact',
      utf8: '✓',
      'contact[name]': details.name,
      'contact[email]': customerEmail,
      'contact[phone]': details.phone || '',
      'contact[subject]': 'New order ' + details.orderId,
      'contact[body]': body
    });

    fetch('/contact', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: params.toString()
    }).catch(function () {});
  }

  function initPaymentTutorialPage(scope) {
    var root = scope || document.querySelector('[data-payment-tutorial]');
    if (!root || root.dataset.paymentReady) return;
    root.dataset.paymentReady = 'true';

    var configEl = root.querySelector('[data-payment-config]');
    var config = { advanceAmount: 300, whatsappNumber: '923045833352' };
    if (configEl) {
      try { config = JSON.parse(configEl.textContent); } catch (e) {}
    }

    var params = new URLSearchParams(window.location.search);
    var orderId = params.get('order') || '';
    var payment = params.get('payment') || '';
    var pending = null;

    try {
      pending = JSON.parse(sessionStorage.getItem(PENDING_ORDER_KEY) || 'null');
    } catch (e) {
      pending = null;
    }

    if (!orderId && pending && pending.orderId) {
      orderId = pending.orderId;
    }

    if (orderId) {
      var orderWrap = root.querySelector('[data-payment-order-wrap]');
      if (orderWrap) orderWrap.hidden = false;
      root.querySelectorAll('[data-payment-order-id], [data-payment-order-id-inline]').forEach(function (el) {
        el.textContent = orderId;
      });
    }

    var waUrl = pending && pending.waUrl
      ? pending.waUrl
      : 'https://wa.me/' + (config.whatsappNumber || '923045833352') + '?text=' +
        encodeURIComponent('Hi ' + SHOP_NAME + '! Here is my Rs. ' + (config.advanceAmount || 300) + ' advance payment screenshot for order ' + (orderId || '') + '.');

    var waBtn = root.querySelector('[data-payment-wa]');
    if (waBtn) waBtn.href = waUrl;

    if (!payment && pending && pending.payment) {
      payment = pending.payment;
    }

    function highlightPaymentMethod(method) {
      if (!method) return;
      var selectedWrap = root.querySelector('[data-payment-selected]');
      var selectedMethod = root.querySelector('[data-payment-selected-method]');
      if (selectedWrap && selectedMethod) {
        if (method === 'COD') {
          selectedMethod.textContent = 'Cash on Delivery (pay advance online via any account below)';
        } else {
          selectedMethod.textContent = method;
        }
        selectedWrap.hidden = false;
      }
      root.querySelectorAll('[data-payment-account]').forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-payment-account') === method);
      });
    }

    highlightPaymentMethod(payment);

    root.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });

    var tutorialCard = root.querySelector('.payment-tutorial__card');
    if (tutorialCard && orderId) {
      window.setTimeout(function () {
        tutorialCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    }
  }

  function initContactHours() {
    var root = document.querySelector('[data-contact-hours]');
    if (!root) return;

    var timezone = root.getAttribute('data-timezone') || 'Asia/Karachi';
    var openHour = parseInt(root.getAttribute('data-open-hour'), 10);
    var closeHour = parseInt(root.getAttribute('data-close-hour'), 10);
    if (isNaN(openHour)) openHour = 10;
    if (isNaN(closeHour)) closeHour = 22;

    var liveEl = root.querySelector('[data-live-datetime]');
    var statusEl = root.querySelector('[data-hours-status]');
    var dayEls = root.querySelectorAll('[data-day]');

    function getNowParts() {
      var now = new Date();
      var weekday = now.toLocaleString('en-US', { timeZone: timezone, weekday: 'long' });
      var dayNum = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].indexOf(weekday);
      var hour24 = parseInt(now.toLocaleString('en-US', {
        timeZone: timezone,
        hour: 'numeric',
        hour12: false
      }), 10);
      if (hour24 === 24) hour24 = 0;

      var minute = parseInt(now.toLocaleString('en-US', {
        timeZone: timezone,
        minute: 'numeric'
      }), 10);

      var timeLabel = now.toLocaleString('en-US', {
        timeZone: timezone,
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });

      return {
        dayNum: dayNum >= 0 ? dayNum : 0,
        hour24: hour24,
        minute: minute,
        dateLabel: weekday + ' · ' + timeLabel + ' PKT'
      };
    }

    function tick() {
      var now = getNowParts();
      var minutes = now.hour24 * 60 + now.minute;
      var openMinutes = openHour * 60;
      var closeMinutes = closeHour * 60;
      var isOpen = minutes >= openMinutes && minutes < closeMinutes;

      if (liveEl) {
        liveEl.textContent = now.dateLabel;
      }

      if (statusEl) {
        statusEl.textContent = isOpen ? 'Open now' : 'Closed';
        statusEl.classList.toggle('is-closed', !isOpen);
      }

      dayEls.forEach(function (el) {
        var day = parseInt(el.getAttribute('data-day'), 10);
        el.classList.toggle('is-today', day === now.dayNum);
      });
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initStaticPageReveal() {
    unlockPageScroll();
    document.querySelectorAll('.contact-page .reveal, .shop-page .reveal, .site-footer .reveal, .info-page .reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  initContactHours();
  initCheckoutPage();
  initPaymentTutorialPage();
  initAccountPage();
  initSearchModal();
  initDemoProductView();
  init404Router();
  initStaticPageReveal();
  initProductPage();

  window.addEventListener('pageshow', unlockPageScroll);
})();
